<div class="notification-bell-container">
  <!-- Bell Icon Button -->
  <button
    class="bell-button"
    (click)="toggleDropdown()"
    [class.active]="isDropdownOpen"
    [class.ringing]="isBellRinging"
    [attr.aria-label]="'notifications.title' | translate"
    title="{{ 'notifications.title' | translate }}"
    >
    <img src="assets/icons/bell.svg" alt="notifications" class="bell-icon" width="22" height="22" />
    <!-- Unread Count Badge -->
    @if (unreadCount > 0) {
      <span class="badge">
        {{ unreadCount > 99 ? '99+' : unreadCount }}
      </span>
    }
  </button>

  <!-- Dropdown Menu -->
  @if (isDropdownOpen) {
    <div class="notification-dropdown" [class.open]="isDropdownOpen">
      <div class="dropdown-header">
        <h3>{{ 'notifications.title' | translate }}</h3>
        @if (unreadCount > 0) {
          <button
            class="mark-all-read-btn"
            (click)="markAllAsRead()"
            [title]="'notifications.markAllAsRead' | translate"
            >
            {{ 'notifications.markAllAsRead' | translate }}
          </button>
        }
      </div>
      <!-- Notifications List -->
      <div class="notifications-list">
        @if (isLoading) {
          <div class="loading-state">
            <p>{{ 'notifications.loading' | translate }}</p>
          </div>
        }
        @if (!isLoading && notifications.length === 0) {
          <div class="empty-state">
            <p>{{ 'notifications.empty' | translate }}</p>
          </div>
        }
        @if (!isLoading && notifications.length > 0) {
          <div class="notification-items">
            @for (notification of notifications; track notification) {
              <div
                class="notification-item"
                [class.unread]="!notification.isRead"
                [style.cursor]="notification.resourceType === ResourceType.File ? 'pointer' : 'default'"
                >
                <!-- Notification Content -->
                <div
                  class="notification-content"
                  (click)="notification.resourceType === ResourceType.File ? navigateToFile(notification) : markAsRead(notification)"
                  [title]="notification.resourceType === ResourceType.File ? 'Click to open file' : ''"
                  >
                  <div class="notification-header">
                    <span class="resource-type" [class.file]="notification.resourceType === ResourceType.File" [class.service]="notification.resourceType === ResourceType.Service">
                      {{ notification.resourceType === ResourceType.File ? 'File' : 'Service' }}
                    </span>
                    <span class="timestamp">{{ getRelativeTime(notification.createdAt) }}</span>
                  </div>
                  <p class="notification-message">
                    {{ getNotificationMessage(notification) }}
                  </p>
                </div>
                <!-- Delete Button -->
                <button
                  class="delete-btn"
                  (click)="deleteNotification(notification.id)"
                  [title]="'notifications.delete' | translate"
                  aria-label="Delete notification"
                  >
                  ✕
                </button>
              </div>
            }
          </div>
        }
        <!-- Load More Button -->
        @if (!isLoading && hasMoreNotifications) {
          <div class="pagination-container">
            <button
              class="load-more-btn"
              (click)="loadMoreNotifications()"
              [disabled]="isLoadingMore"
              >
              @if (!isLoadingMore) {
                <span>{{ 'notifications.loadMore' | translate }}</span>
              }
              @if (isLoadingMore) {
                <span>{{ 'common.loading' | translate }}</span>
              }
            </button>
          </div>
        }
      </div>
      <!-- Footer -->
      <!-- <div class="dropdown-footer">
      <button class="view-all-btn" (click)="viewAllNotifications()">
        {{ 'notifications.viewAll' | translate }}
      </button>
    </div> -->
  </div>
}

<!-- Overlay to close dropdown -->
@if (isDropdownOpen) {
  <div
    class="notification-overlay"
    (click)="closeDropdown()"
  ></div>
}
</div>
